export const twoDP = (num: number | null) => (num === null || num === 0 ? '' : `${num.toFixed(2)}`);

export const makeChangeClass = (input: number | null): string => {
  if (input === null || input === 0) return 'grey';
  return input > 0 ? 'positive-value' : 'negative-value';
};
